module.exports = __webpack_public_path__ + "img/service-digital-1.a53b4434.png";